<template>
  <div>
    <!-- dialog -->
    <el-dialog title="รายละเอียดผู้ใช้งาน" :visible.sync="show"  :before-close="handleClose">
      <!-- <h4>{{data_dialog}}</h4> -->
      <div class="box-img">
        <div class="show_img">
          <img
            :src="data.profile_image"
          />
          
        </div>
      </div>
      <div class="layout_detail_modal">
        <div class="row new-space-user">
          <label for="อีเมล">อีเมล : {{data.email}}</label>
        </div>
        <div class="row new-space-user">
          <label for="เบอร์โทรศัพท์">เบอร์โทรศัพท์ : {{data.phone_number}}</label>
        </div>
        <div class="row new-space-user">
          <label for="ชื่อผู้ใช้งาน">เครือข่าย : {{data.provider_short_name}}</label>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelPosition: "top",
      show: false
    };
  },
  created() {
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["data", "dialog"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
